var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M0,1.41,4.33,6,0,10.59,1.33,12,7,6,1.33,0Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }